import { getIn } from 'fun-util';

export default popup => (
  getIn(popup, 'eSignSettings', 'address') ||
  getIn(popup, 'requestSettings', 'address')
);



// WEBPACK FOOTER //
// ./src-react/Popups/helpers/getAssignee.jsx